export default __webpack_public_path__ + "static/leaf-cf7f2f91601a559b99c39414acedb6e9.png";